<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="referenceswidget__background module__background"
        ></app-modulebackground>
        <div
            class="referenceswidget__container module__container"
            v-bind:class="{
                'container__boxed--half': [1, 2].includes(module.layout.type),
                container__fluid: [3, 4].includes(module.layout.type),
                container__boxed: [5, 6].includes(module.layout.type)
            }"
        >
            <div class="referenceswidget__inner module__inner">
                <div
                    class="referenceswidget__inner--main module__inner--main"
                    v-bind:class="{
                        'calc-padding--left': [3].includes(module.layout.type),
                        'calc-padding--right': [4].includes(module.layout.type)
                    }"
                >
                    <div
                        class="referenceswidget__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="referenceswidget__inner-col module__inner-col">
                            <div class="referenceswidget__header module__header">
                                <h2
                                    class="referenceswidget__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="referenceswidget__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="referenceswidget__inner-row module__inner-row">
                        <div class="referenceswidget__inner-col module__inner-col">
                            <div class="referenceswidget__content-block module__content-block">
                                <div
                                    class="referenceswidget__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="module.data.text"
                                >
                                    <div class="referenceswidget__inner-row module__inner-row">
                                        <div class="referenceswidget__inner-col module__inner-col">
                                            <div
                                                class="referenceswidget__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="referenceswidget__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="referenceswidget__inner-row module__inner-row">
                                        <div class="referenceswidget__inner-col module__inner-col">
                                            <div>
                                                <ul
                                                    class="referenceswidget__references-list module__list"
                                                >
                                                    <li
                                                        class="referenceswidget__reference-item module__list-item col__width--full border-color-highlighted font-bold"
                                                        v-bind:class="{
                                                            'col__width--one-quarter': [
                                                                5,
                                                                6
                                                            ].includes(module.layout.type)
                                                        }"
                                                        v-for="items__value in items"
                                                        v-bind:key="items__value.id"
                                                        :data-preset-id="items__value.preset_id"
                                                    >
                                                        <component
                                                            :is="
                                                                getPageUrlFromType('references')
                                                                    ? 'a'
                                                                    : 'span'
                                                            "
                                                            v-on:click.prevent="scrollInsideEditor"
                                                            v-bind:href="
                                                                getPageUrlFromType('references')
                                                                    ? getPageUrlFromType(
                                                                          'references'
                                                                      ) +
                                                                      '/#' +
                                                                      items__value.id
                                                                    : null
                                                            "
                                                            v-bind:class="{
                                                                'referenceswidget__reference-item--inner flex--wrap font-bold module__link': [
                                                                    1,
                                                                    2,
                                                                    3,
                                                                    4,
                                                                    5,
                                                                    6
                                                                ].includes(module.layout.type)
                                                            }"
                                                        >
                                                            <app-moduleimage
                                                                v-if="
                                                                    [5, 6].includes(
                                                                        module.layout.type
                                                                    ) && image(items__value)
                                                                "
                                                                :data="image(items__value)"
                                                                :width="375"
                                                                :height="250"
                                                                :tag="'img'"
                                                                :custom-class="
                                                                    'referenceswidget__reference-image referenceswidget__moduleimage'
                                                                "
                                                            ></app-moduleimage>
                                                            <span
                                                                class="referenceswidget__reference-title module__label font-bold color-p"
                                                                >{{ items__value.data.name }}</span
                                                            >
                                                            <span
                                                                class="referenceswidget__reference-icon"
                                                                v-if="
                                                                    [1, 2, 3, 4].includes(
                                                                        module.layout.type
                                                                    )
                                                                "
                                                                >»</span
                                                            >
                                                        </component>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="referenceswidget__inner-row module__inner-row"
                        v-if="getPageUrlFromType('references')"
                    >
                        <div class="referenceswidget__inner-col module__inner-col">
                            <div class=" referenceswidget__cta module__cta">
                                <app-modulebutton
                                    :href="getPageUrlFromType('references')"
                                    :custom-class="
                                        'referenceswidget__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                >
                                    Erfahren Sie mehr
                                </app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="referenceswidget__inner--image module__inner--image"
                    v-if="
                        [3, 4].includes(module.layout.type) &&
                            module.data.image &&
                            module.data.image.id
                    "
                >
                    <app-moduleimage
                        v-if="[3, 4].includes(module.layout.type)"
                        :data="module.data.image"
                        :tag="'div'"
                        :custom-class="'referenceswidget__moduleimage module__moduleimage'"
                    ></app-moduleimage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters, mapActions } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    methods: {
        ...mapActions(['scrollInsideEditor']),
        image(items__value) {
            if (
                !('data' in items__value) ||
                !('images' in items__value.data) ||
                Object.keys(items__value.data.images).length === 0
            ) {
                return null;
            }
            let images = toArray(items__value.data.images);
            images = images.filter((i) => i !== undefined && i !== null && i !== '');
            return images[0];
        }
    },
    computed: {
        ...mapGetters(['getListItems', 'getPageUrlFromType']),
        items() {
            let items = this.getListItems('deha.user.misc.references');
            return items.slice(0, 4);
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
